import React, { useState, useEffect, useRef } from "react";
import { Button, Col, Container, Form, Row, Card } from "react-bootstrap";
import Title from "../../Components/Utils";
import ReCAPTCHA from "react-google-recaptcha";
import { BASEURL } from "../../CONSTANTS";
import { useScreenSize, useCustomScreen } from "../../Components/Utils";
import toast from "react-hot-toast";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCircleExclamation,
  faCircleCheck,
} from "@fortawesome/free-solid-svg-icons";

export default function ContactInfo() {
  const initialState = {
    name: "",
    email: "",
    phone: "",
    subject: "",
    message: "",
  };
  const {
    isSmallScreen,
    isMediumScreen,
    isLargeScreen,
    isXlScreen,
    isXxlScreen,
    is4kScreen,
  } = useScreenSize();
  const { isIpadProPortrait } = useCustomScreen();
  const [contactDetails, setContactDetails] = useState(initialState);
  const [errors, setErrors] = useState({});
  const [touched, setTouched] = useState({});
  const [loading, setLoading] = useState(false);
  const [captchaVerified, setCaptchaVerified] = useState(false);
  const siteKey = process.env.REACT_APP_RECAPTCHA_SITE_KEY;
  const devicePixelRatio = window.devicePixelRatio;
  const recaptchaRef = useRef(null);


  const handleChange = (field) => (e) => {
    let value = e.target.value;
    setContactDetails((prev) => ({
      ...prev,
      [field]: value,
    }));
    // Clear error when user starts typing
    if (value && errors[field]) {
      setErrors((prev) => ({ ...prev, [field]: "" }));
    }
  };

  // Handle blur: user leaves the field
const handleBlur = (field) => () => {
  setTouched((prev) => ({ ...prev, [field]: true }));
  validateField(field, contactDetails[field]);
};

  // Validate individual field
const validateField = (field, value) => {
  let error = "";
  if (!value || value.trim() === "") {
    error = `${field.charAt(0).toUpperCase() + field.slice(1)} is required`;
  } else if (field === "email" && !/\S+@\S+\.\S+/.test(value)) {
    error = "Email is invalid";
  } else if (field === "phone") {
    const phoneRegex = /^\d+$/;
    if (!phoneRegex.test(value)) {
      error = "Phone must contain only digits";
    } else if (value.length < 9 || value.length > 13) {
      error = "Phone must be 9 to 13 digits";
    }
  }
  setErrors((prev) => ({ ...prev, [field]: error }));
  return error;
};
  const onChange = async (value) => {
    console.log("Captcha value:", value);
    setCaptchaVerified(!!value);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const isValid = Object.keys(contactDetails).every((field) => {
      return validateField(field, contactDetails[field]) === "";
    });
    if (!isValid || !captchaVerified) return;

    try {
      setLoading(true);
      const response = await fetch(`${BASEURL}api/Email/contact-us`, {
        method: "POST",
        body: JSON.stringify(contactDetails),
        headers: {
          "Content-Type": "application/json",
        },
      });
      if (response.ok) {
        toast.success("Success", {
          duration: 6000,
          icon: (
            <FontAwesomeIcon
              style={{
                color: "green",
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
              icon={faCircleCheck}
            />
          ),
          style: {
            backgroundColor: "#E7EFC7",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
        setContactDetails(initialState);
        setErrors({});
        setTouched({});
        setCaptchaVerified(false);
        recaptchaRef.current?.reset();
        localStorage.removeItem("_grecaptcha");
      } else {
        toast.error("Something went wrong", {
          duration: 6000,
          icon: (
            <FontAwesomeIcon
              style={{
                fontSize: is4kScreen
                  ? "1.9rem"
                  : isXxlScreen
                  ? "1.6rem"
                  : isXlScreen
                  ? "1.5rem"
                  : isIpadProPortrait
                  ? "1.8rem"
                  : isLargeScreen
                  ? "0.9rem"
                  : isMediumScreen
                  ? "1.4rem"
                  : "1rem",
              }}
              icon={faCircleExclamation}
              
            />
          ),
          style: {
            backgroundColor: "#FFC1B4",
            color: "red",
            fontSize: is4kScreen
              ? "1.9rem"
              : isXxlScreen
              ? "1.15rem"
              : isXlScreen
              ? "1rem"
              : isIpadProPortrait
              ? "1.8rem"
              : isLargeScreen
              ? "1rem"
              : isMediumScreen
              ? "1.1rem"
              : "1rem",
            marginTop: is4kScreen ? "2rem" : isIpadProPortrait ? "2rem" : "",
          },
        });
       setCaptchaVerified(false);
  recaptchaRef.current?.reset();
      }
    } catch (err) {
       console.log(err);
  setCaptchaVerified(false);
  recaptchaRef.current?.reset();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://www.google.com/recaptcha/api.js";
    script.async = true;
    script.defer = true;
    document.body.appendChild(script);
    script.onload = () => {
      console.log("reCAPTCHA loaded:", window.grecaptcha);
    };
  }, []);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div
      style={{
        marginBottom: "2em",
        marginTop: isSmallScreen
          ? "6rem"
          : isMediumScreen
          ? "5rem"
          : isLargeScreen
          ? "7rem"
          : isXlScreen && devicePixelRatio >= 1.5
          ? "5rem"
          : isXlScreen
          ? "3rem"
          : "6rem",
        height: "70%",
        minHeight: "100vh",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Container>
        <Row>
          <Col xs={12} md={12} lg={isIpadProPortrait ? 12 : 5} className="pb-3">
            <Card style={{ boxShadow: "0px 9px 26px 6px rgba(0,0,0,0.1)" }}>
              <Card.Body>
                <Row>
                  <Col sm={12} md={12} className="p-3">
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: is4kScreen
                          ? "3rem"
                          : isXxlScreen
                          ? "1.8rem"
                          : isXlScreen
                          ? "1.6rem"
                          : isIpadProPortrait
                          ? "2.5rem"
                          : isLargeScreen
                          ? "1.8rem"
                          : isMediumScreen
                          ? "1.8rem"
                          : isSmallScreen
                          ? "1.8rem"
                          : "",
                      }}
                    >
                      Contact
                    </p>
                    <hr></hr>
                    <p
                      className="text-center"
                      style={{
                        fontSize: is4kScreen
                          ? "2.3rem"
                          : isXxlScreen
                          ? "1.3rem" 
                          : isXlScreen
                          ? "1rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.2rem"
                          : isMediumScreen
                          ? "1.3rem"
                          : isSmallScreen
                          ? "1.1rem"
                          : "",
                      }}
                    >
                      Toll Free: (805) 746-5823
                    </p>
                    <p
                      className="text-center"
                      style={{
                        fontSize: is4kScreen
                          ? "2.3rem"
                          : isXxlScreen
                          ? "1.3rem"
                          : isXlScreen
                          ? "1rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.2rem"
                          : isMediumScreen
                          ? "1.3rem"
                          : isSmallScreen
                          ? "1.1rem"
                          : "",
                      }}
                    >
                      reports@rooftopmeasurements.com
                    </p>
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: is4kScreen
                          ? "3rem"
                          : isXxlScreen
                          ? "1.8rem"
                          : isXlScreen
                          ? "1.6rem"
                          : isIpadProPortrait
                          ? "2.5rem"
                          : isLargeScreen
                          ? "1.8rem"
                          : isMediumScreen
                          ? "1.8rem"
                          : isSmallScreen
                          ? "1.8rem"
                          : "",
                        paddingTop: "20px",
                      }}
                    >
                      Customer Service Hours
                    </p>
                    <hr></hr>
                    <p
                      className="text-center"
                      style={{
                        fontSize: is4kScreen
                          ? "2.3rem"
                          : isXxlScreen
                          ? "1.3rem"
                          : isXlScreen
                          ? "1rem"
                          : isIpadProPortrait
                          ? "1.8rem"
                          : isLargeScreen
                          ? "1.2rem"
                          : isMediumScreen
                          ? "1.3rem"
                          : isSmallScreen
                          ? "1.1rem"
                          : "",
                      }}
                    >
                      Mon-Fri 8:00am - 5:00pm PST
                    </p>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
          <Col xs={12} md={12} lg={isIpadProPortrait ? 12 : 7}>
            <Card
              style={{
                boxShadow: "0px 9px 26px 6px rgba(0,0,0,0.1)",
              }}
            >
              <Card.Body>
                <Row>
                  <Col md={12}>
                    <p
                      style={{
                        textAlign: "center",
                        fontSize: is4kScreen
                          ? "3rem"
                          : isXxlScreen
                          ? "1.6rem"
                          : isXlScreen
                          ? "1.5rem"
                          : isIpadProPortrait
                          ? "2.5rem"
                          : isLargeScreen
                          ? "1.6rem"
                          : isMediumScreen
                          ? "1.8rem"
                          : isSmallScreen
                          ? "1.8rem"
                          : "",
                      }}
                      className="login-heading"
                    >
                      Send Us a Message
                    </p>
                    <p
                      style={{
                        fontSize: is4kScreen
                          ? "2rem"
                          : isXxlScreen
                          ? "1.1rem"
                          : isXlScreen
                          ? "1rem"
                          : isIpadProPortrait
                          ? "1.67rem"
                          : isLargeScreen
                          ? "1rem"
                          : isMediumScreen
                          ? "1.2rem"
                          : "15px",
                        fontFamily: "Oswald,Arial",
                      }}
                    >
                      Have a question, comment, or want to learn more about our
                      services? Simply fill out the form below and one of our
                      customer service representatives will be in touch with you
                      shortly.
                    </p>
                    <Form
                      className="contact-us"
                      style={{ padding: "0px 2em" }}
                      onSubmit={handleSubmit}
                    >
                      {/* Name Field */}
                      <Form.Group
                        className="mb-2 row"
                        controlId="formBasicLast"
                      >
                        <Form.Label
                          className={`col-md-${isLargeScreen ? "4" : "3"} `}
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXlScreen
                              ? "1.1rem"
                              : isIpadProPortrait
                              ? "1.6rem"
                              : isLargeScreen
                              ? "1.1rem"
                              : isMediumScreen
                              ? "1.2rem"
                              : isSmallScreen
                              ? "1rem"
                              : "",
                          }}
                        >
                          Your Name<span style={{ fontWeight: "bold" }}>*</span> :
                        </Form.Label>
                        <div
                          className={`col-md-${
                            isLargeScreen ? "7" : "3"
                          } d-flex flex-column`}
                          style={{
                            width: isXlScreen
                              ? "60%"
                              : isXxlScreen
                              ? "60%"
                              : is4kScreen
                              ? "60%"
                              : isMediumScreen
                              ? "60%"
                              : "",
                          }}
                        >
                          <Form.Control
                            type="text"
                            value={contactDetails.name}
                            onChange={handleChange("name")}
                            onBlur={handleBlur("name")}
                            isInvalid={!!errors.name && touched.name}
                            required
                          />
                          {errors.name && touched.name && (
                            <div
                              style={{
                                color: "red",
                                fontSize: "0.9rem",
                                marginTop: "0.25rem",
                                textAlign: "left",
                              }}
                            >
                              {errors.name}
                            </div>
                          )}
                        </div>
                      </Form.Group>

                      {/* Email Field */}
                      <Form.Group
                        className="mb-2 row"
                        controlId="formBasicCompany"
                      >
                        <Form.Label
                          className={`col-md-${isLargeScreen ? "4" : "3"}`}
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXlScreen
                              ? "1.1rem"
                              : isIpadProPortrait
                              ? "1.6rem"
                              : isLargeScreen
                              ? "1.1rem"
                              : isMediumScreen
                              ? "1.2rem"
                              : isSmallScreen
                              ? "1rem"
                              : "",
                          }}
                        >
                          Email Address<span style={{ fontWeight: "bold" }}>*</span> :
                        </Form.Label>
                        <div
                          className={`col-md-${
                            isLargeScreen ? "7" : "3"
                          } d-flex flex-column`}
                          style={{
                            width: isXlScreen
                              ? "60%"
                              : isXxlScreen
                              ? "60%"
                              : is4kScreen
                              ? "60%"
                              : isMediumScreen
                              ? "60%"
                              : "",
                          }}
                        >
                          <Form.Control
                            type="email"
                            value={contactDetails.email}
                            onChange={handleChange("email")}
                            onBlur={handleBlur("email")}
                            isInvalid={!!errors.email && touched.email}
                            required
                          />
                          {errors.email && touched.email && (
                            <div
                              style={{
                                color: "red",
                                fontSize: "0.9rem",
                                marginTop: "0.25rem",
                                textAlign: "left",
                              }}
                            >
                              {errors.email}
                            </div>
                          )}
                        </div>
                      </Form.Group>

                      {/* Phone Field */}
                      <Form.Group
                        className="mb-2 row"
                        controlId="formBasicName"
                      >
                        <Form.Label
                          className={`col-md-${isLargeScreen ? "4" : "3"}`}
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXlScreen
                              ? "1.1rem"
                              : isIpadProPortrait
                              ? "1.6rem"
                              : isLargeScreen
                              ? "1.1rem"
                              : isMediumScreen
                              ? "1.2rem"
                              : isSmallScreen
                              ? "1rem"
                              : "",
                          }}
                        >
                          Phone Number<span style={{ fontWeight: "bold" }}>*</span> :
                        </Form.Label>
                        <div
                          className={`col-md-${
                            isLargeScreen ? "7" : "3"
                          } d-flex flex-column`}
                          style={{
                            width: isXlScreen
                              ? "60%"
                              : isXxlScreen
                              ? "60%"
                              : is4kScreen
                              ? "60%"
                              : isMediumScreen
                              ? "60%"
                              : "",
                          }}
                        >
                          <Form.Control
                            type="text"
                            value={contactDetails.phone}
                            onChange={handleChange("phone")}
                            onBlur={handleBlur("phone")}
                            isInvalid={!!errors.phone && touched.phone}
                            required
                          />
                          {errors.phone && touched.phone && (
                            <div
                              style={{
                                color: "red",
                                fontSize: "0.9rem",
                                marginTop: "0.25rem",
                                textAlign: "left",
                              }}
                            >
                              {errors.phone}
                            </div>
                          )}
                        </div>
                      </Form.Group>

                      {/* Subject Field */}
                      <Form.Group
                        className="mb-2 row"
                        controlId="formBasicLast"
                      >
                        <Form.Label
                          className={`col-md-${isLargeScreen ? "4" : "3"}`}
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isXlScreen
                              ? "1.1rem"
                              : isIpadProPortrait
                              ? "1.6rem"
                              : isLargeScreen
                              ? "1.1rem"
                              : isMediumScreen
                              ? "1.2rem"
                              : isSmallScreen
                              ? "1rem"
                              : "",
                          }}
                        >
                          Subject<span style={{ fontWeight: "bold" }}>*</span> :
                        </Form.Label>
                        <div
                          className={`col-md-${
                            isLargeScreen ? "7" : "3"
                          } d-flex flex-column`}
                          style={{
                            width: isXlScreen
                              ? "60%"
                              : isXxlScreen
                              ? "60%"
                              : is4kScreen
                              ? "60%"
                              : isMediumScreen
                              ? "60%"
                              : "",
                          }}
                        >
                          <Form.Control
                            type="text"
                            value={contactDetails.subject}
                            onChange={handleChange("subject")}
                            onBlur={handleBlur("subject")}
                            isInvalid={!!errors.subject && touched.subject}
                            required
                          />
                          {errors.subject && touched.subject && (
                            <div
                              style={{
                                color: "red",
                                fontSize: "0.9rem",
                                marginTop: "0.25rem",
                                textAlign: "left",
                              }}
                            >
                              {errors.subject}
                            </div>
                          )}
                        </div>
                      </Form.Group>

                    {/* Message Field */}
<Form.Group
  className="mb-2 row"
  controlId="formBasicCompany"
>
  <Form.Label
    className={`col-md-${isLargeScreen ? "4" : "3"}`}
    style={{
      fontSize: is4kScreen
        ? "2rem"
        : isXlScreen
        ? "1.1rem"
        : isIpadProPortrait
        ? "1.6rem"
        : isLargeScreen
        ? "1.1rem"
        : isMediumScreen
        ? "1.2rem"
        : isSmallScreen
        ? "1rem"
        : "",
    }}
  >
    Message<span style={{ fontWeight: "bold" }}>*</span> :
  </Form.Label>
  <div
    className={`col-md-${
      isLargeScreen ? "7" : "3"
    } d-flex flex-column`}
    style={{
      width: isXlScreen
        ? "60%"
        : isXxlScreen
        ? "60%"
        : is4kScreen
        ? "60%"
        : isMediumScreen
        ? "60%"
        : "",
    }}
  >
    <textarea
      className="form-control"
      value={contactDetails.message}
      onChange={handleChange("message")}
      onBlur={handleBlur("message")}
      style={{
        minHeight: "120px",
        height: "auto",
        resize: "vertical"
      }}
      rows={5}
      required
    />
    {errors.message && touched.message && (
      <p
        style={{
          color: "red",
          fontSize: "0.9rem",
          marginTop: "0.25rem",
          textAlign: "left",
        }}
      >
        {errors.message}
      </p>
    )}
  </div>
</Form.Group>

                      {/* reCAPTCHA */}
                      <div
                        className="recaptcha-wrapper d-flex justify-content-center align-items-center pt-3 pb-3"
                        style={{
                          marginLeft: isIpadProPortrait
                            ? ""
                            : isLargeScreen
                            ? "4rem"
                            : "",
                          marginRight: is4kScreen
                            ? "2rem"
                            : isXxlScreen
                            ? "3rem"
                            : "",
                        }}
                      >
                        <ReCAPTCHA
                          className="responsive-recaptcha"
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isLargeScreen
                              ? "1.5rem"
                              : "30px",
                          }}
                           ref={recaptchaRef}
                          sitekey={siteKey}
                          onChange={onChange}
                        />
                      </div>

                      {/* Submit Button */}
                      <div
                        className="mb-2"
                        style={{
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                        }}
                      >
                        <Button
                          className="login-btns btn mb-3 col-md-3"
                          type="submit"
                          disabled={!captchaVerified || loading}
                          style={{
                            fontSize: is4kScreen
                              ? "2rem"
                              : isIpadProPortrait
                              ? "1.6rem"
                              : isLargeScreen
                              ? "1.3rem"
                              : "20px",
                            opacity: !captchaVerified && !loading ? 0.6 : 1,
                          }}
                        >
                          {loading ? "Sending..." : "Send"}
                        </Button>
                      </div>
                    </Form>
                  </Col>
                </Row>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container>
    </div>
  );
}